import {
  Box,
  Button,
  Container,
  SelectChangeEvent,
} from "src/components/MuiGenerals";
import { customSx } from "src/utils/styling";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import ThresholdNumberTextField from "./components/ThresholdNumberTextField";
import { ChangeEvent } from "react";
import SpenderAddressSingleSelection from "./components/SpenderAddressSingleSelection";
import MaxNumberOfAddressesNumberTextField from "./components/MaxNumberOfAddressesNumberTextField";
import { useBatchApproveAllowanceFormContext } from "../../contexts";
import LoadingDialog from "src/components/LoadingDialog";
import SmartAccountCheckbox from "./components/SmartAccountCheckbox";
import { isNil } from "lodash";
import PreparedAddressesCheckbox from "./components/PreparedAddressesCheckbox";

function Filters() {
  const {
    fields,
    setFields,
    isLoading,
    onPreview,
    previewParams,
    translate: t,
  } = useBatchApproveAllowanceFormContext();

  const onChange =
    (fieldName: keyof typeof fields) =>
    (
      e:
        | SelectChangeEvent<string>
        | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      setFields((prev) => ({ ...prev, [fieldName]: e.target.value }));
    };

  const canPreview = Object.entries(fields).every(
    ([key, value]) =>
      value !== "" || (key === "threshold" && fields.isPreparedAddresses),
  );

  return (
    <Box
      sx={{
        ...customSx.layoutBox,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1rem",
      }}
    >
      <LoadingDialog forceOpen={isLoading} />
      <Container disableGutters maxWidth={false} sx={customSx.gridFilter}>
        <ChainNameSingleSelection />
        <CurrencySingleSelection />
        <SpenderAddressSingleSelection
          value={fields.spenderAddress}
          onChange={onChange("spenderAddress")}
        />
        <MaxNumberOfAddressesNumberTextField
          value={fields.maxNumberOfAddresses}
          onChange={onChange("maxNumberOfAddresses")}
        />
        <PreparedAddressesCheckbox />
        <ThresholdNumberTextField
          value={fields.threshold}
          onChange={onChange("threshold")}
        />
        {!isNil(previewParams?.smartAccountType) && <SmartAccountCheckbox />}
      </Container>

      <Button
        disabled={!canPreview}
        onClick={onPreview}
        // sx={sx.preview}
        color="secondary"
        variant="contained"
      >
        {t("preview")}
      </Button>
    </Box>
  );
}

export default Filters;
